import React from 'react';
import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Grid from '@mui/material/Grid';
import { default as CustomButton } from '../../../components/atoms/button';
import { saveModalButtonGrid } from '../../../styles';

//Customized Modal using MUI
const MUICustomModal = props => {
  const { t } = useTranslation();
  const {
    onBackDropClick = () => {},
    modalWidth = 700,
    children,
    open = false,
    onSecondoryButtonClick = () => {},
    onPrimaryButton = () => {},
    disableSecondoryButton = false,
    disablePrimaryButton = false,
    primaryButtonTitle = t('Cancel'),
    secondoryButtonTitle = t('Save'),
    borderRadius = '10px',
    customStyle = {},
  } = props;

  //custom box style
  const boxStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: modalWidth,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    p: 4,
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
    outline: 'none',
    borderRadius: borderRadius,
    justifyContent: 'center',
  };

  return (
    <Grid>
      <Modal
        open={open}
        onClose={onBackDropClick} //onBackDrop
      >
        <Box sx={boxStyle}>
          <Grid style={customStyle}>{children}</Grid>
          <Grid style={saveModalButtonGrid}>
            <CustomButton
              title={primaryButtonTitle}
              onClick={onPrimaryButton}
              disabled={disablePrimaryButton}
            />
            <CustomButton
              title={secondoryButtonTitle}
              onClick={onSecondoryButtonClick}
              disabled={disableSecondoryButton}
            />
          </Grid>
        </Box>
      </Modal>
    </Grid>
  );
};

export default MUICustomModal;
